import React from 'react';
import ProductSalesEducationModal from './ProductSalesEducationModal';
// eslint-disable-next-line
import analytics from "../../../../../modules/analytics";
import { renderModalInContext } from '../../../../ui/ModalContext';

/**
 * Open the gift card modal
 */
export const openModal = (modalContext, props) => renderModalInContext(
  closeModal => (
    <ProductSalesEducationModal onCloseModal={closeModal} {...props} />
  ),
  modalContext,
);

export default ProductSalesEducationModal;
